import AppServices from "./appservices";
import { texto_url } from '../utils/helper'
export default class AuthenticationService extends AppServices {
    send(code, state) {
        return this.request("/login-unico/token", "POST", { code, state });
    }

    getData(state) {
        const route = '/login-unico/dados'
        const query = `?state=${state}`
        const url = route + query
        return this.request(url, "GET")
    }

    setExpiration() {
        const time = new Date();
        time.setSeconds(texto_url.expires_in);
        localStorage.setItem('omni_ifs_ts', time);
    }

    setToken() {
        localStorage.setItem('omni_ifs_auth', texto_url.access_token);
    }

    get logged() {
        const ifsAuth = localStorage.getItem('ifs_auth')
        const omniIfsAuth = localStorage.getItem('omni_ifs_auth')
        if (!ifsAuth && omniIfsAuth === 'logged_out') {
            return false
        }
        const userSession = localStorage.getItem('user_session') ? JSON.parse(localStorage.getItem('user_session')) : {}

        if (ifsAuth || (omniIfsAuth !== null && omniIfsAuth !== 'logged_out' && userSession.type === 'Success')) {
            return true
        }
        return false
    }

    get isLogged() {
        let atual = new Date();
        let ts = Date.parse(localStorage.getItem('omni_ifs_ts'));

        let isLoggedIn = (localStorage.getItem('omni_ifs_auth') !== null && ts > atual);

        if (!isLoggedIn) {
            // localStorage.removeItem('miToken');
            localStorage.removeItem('omni_ifs_auth');
            localStorage.removeItem('omni_ifs_ts');
        }
        return isLoggedIn
    }
}
